export const iconFontAwesomeMapsSquareParking = (
	<i className="fa-solid fa-square-parking"></i>
);
